import {call, put, select, take, takeLatest} from 'redux-saga/effects'

import * as addToLookActions from '../../actions/addToLook'
import * as apiActions from '../../actions/api'
import * as crossSelectors from '../../store/cross'
import * as looksActions from '../../actions/looks'
import * as looksSelectors from '../../store/looks'

import {handleFlowCompletion} from './helpers'

/**
 * Handles the logic for creating a new HTO look if we don't have one
 *
 * @returns {Object} A look object
 * @generator
 */
export function* handleNewHtoLookWorker() {
  yield put(apiActions.createEventLook('Free Home Try-On', 'hto', true))
  const {payload: response} = yield take(apiActions.CREATE_EVENT_LOOK_SUCCESS)
  yield put(looksActions.addLook(response))
  const htoLooks = yield select(looksSelectors.getHtoLooks)
  return htoLooks[0]
}

/**
 * This is a temporary function used to allow us to test logic without being
 * hamstrung by calling a thunk from a saga. This logic can be moved back to
 * `addProductToHtoLookWorker` once we have removed the need for the thunk.
 */
export function* handleAddProductToHtoLookWorker() {
  const htoLooks = yield select(looksSelectors.getHtoLooks)
  let htoLook = htoLooks[0]
  if (!htoLook) {
    htoLook = yield call(handleNewHtoLookWorker)
  }
  const products = yield select(crossSelectors.addToHtoLookProductsArray)
  yield put(
    addToLookActions.addProductsToExistingLook({
      lookId: htoLook.id,
      products,
    }),
  )
  yield call(handleFlowCompletion)
}

/**
 * Fields the call to add a product to a HTO. Contains some back-and-forth with
 * the `addToHtoLook` thunk for now as we still need `validateAddToLook`.
 *
 * @generator
 */
export function* addProductToHtoLookWorker() {
  const thunk = yield call(addToLookActions.addToHtoLook)
  yield put(thunk)
  yield take(addToLookActions.HANDLE_ADDING_PRODUCT_TO_HTO_LOOK)
  yield call(handleAddProductToHtoLookWorker)
}

export function* addProductToHtoLookSaga() {
  yield takeLatest(addToLookActions.ADD_PRODUCT_TO_HTO_LOOK, addProductToHtoLookWorker)
}
